import { collection, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../firebase';

// 推荐数据接口
export interface TestimonialItem {
    id: string;
    bodyEn: string;
    bodyCn: string;
    authorName: string;
    authorRole: string;
    authorAvatar?: string;
    order: number;
    active: boolean;
    tags: string[];
    category: string;
}

// 获取所有活跃的推荐数据，按order排序
export const getActiveTestimonials = async (): Promise<TestimonialItem[]> => {
    try {
        const testimonialsRef = collection(db, 'testimonials');
        const q = query(
            testimonialsRef,
            where('active', '==', true),
            orderBy('order', 'asc'),
            orderBy('authorName', 'asc')
        );
        
        const querySnapshot = await getDocs(q);
        const testimonials: TestimonialItem[] = [];
        
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            // 数据清洗和验证
            if (data.bodyEn && data.bodyCn && data.authorName && data.authorRole) {
                testimonials.push({
                    id: doc.id,
                    bodyEn: data.bodyEn || '',
                    bodyCn: data.bodyCn || '',
                    authorName: data.authorName || '',
                    authorRole: data.authorRole || '',
                    authorAvatar: data.authorAvatar || undefined,
                    order: data.order || 0,
                    active: data.active !== false,
                    tags: Array.isArray(data.tags) ? data.tags : [],
                    category: data.category || '综合评价'
                });
            }
        });
        
        return testimonials;
    } catch (error) {
        console.error('获取推荐数据失败:', error);
        return [];
    }
};

// 按分类获取推荐数据
export const getTestimonialsByCategory = async (category: string): Promise<TestimonialItem[]> => {
    try {
        const testimonialsRef = collection(db, 'testimonials');
        const q = query(
            testimonialsRef,
            where('active', '==', true),
            where('category', '==', category),
            orderBy('order', 'asc'),
            limit(10)
        );
        
        const querySnapshot = await getDocs(q);
        const testimonials: TestimonialItem[] = [];
        
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            if (data.bodyEn && data.bodyCn && data.authorName && data.authorRole) {
                testimonials.push({
                    id: doc.id,
                    bodyEn: data.bodyEn || '',
                    bodyCn: data.bodyCn || '',
                    authorName: data.authorName || '',
                    authorRole: data.authorRole || '',
                    authorAvatar: data.authorAvatar || undefined,
                    order: data.order || 0,
                    active: data.active !== false,
                    tags: Array.isArray(data.tags) ? data.tags : [],
                    category: data.category || '综合评价'
                });
            }
        });
        
        return testimonials;
    } catch (error) {
        console.error(`获取分类 ${category} 的推荐数据失败:`, error);
        return [];
    }
};

// 获取指定数量的推荐数据（用于首页展示）
export const getFeaturedTestimonials = async (maxCount: number = 5): Promise<TestimonialItem[]> => {
    try {
        const testimonialsRef = collection(db, 'testimonials');
        const q = query(
            testimonialsRef,
            where('active', '==', true),
            orderBy('order', 'asc'),
            limit(maxCount)
        );
        
        const querySnapshot = await getDocs(q);
        const testimonials: TestimonialItem[] = [];
        
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            if (data.bodyEn && data.bodyCn && data.authorName && data.authorRole) {
                testimonials.push({
                    id: doc.id,
                    bodyEn: data.bodyEn || '',
                    bodyCn: data.bodyCn || '',
                    authorName: data.authorName || '',
                    authorRole: data.authorRole || '',
                    authorAvatar: data.authorAvatar || undefined,
                    order: data.order || 0,
                    active: data.active !== false,
                    tags: Array.isArray(data.tags) ? data.tags : [],
                    category: data.category || '综合评价'
                });
            }
        });
        
        return testimonials;
    } catch (error) {
        console.error('获取精选推荐数据失败:', error);
        return [];
    }
}; 